import React from 'react'
import { StatItem } from '../StatItem/StatItem'
import { Box, IconButton, Theme, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { DamageTranslation } from '../../../../../../../../api/types/item'
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded'
import { useMutation } from '@tanstack/react-query'
import { mutationDmgRoll } from '../../../../../../../../api/mutations'
import { extractMessage } from '../../../../../../../../utils'
import { useGlobalError } from '../../../../../../../../context/GlobalError'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
    },
  })
)

const RollButton: React.FC<{ isDisabled: boolean; onClick: () => void }> = ({
  isDisabled,
  onClick,
}) => {
  return (
    <IconButton size="small" disabled={isDisabled} onClick={onClick}>
      <CasinoRoundedIcon color={'primary'} fontSize={'small'} />
    </IconButton>
  )
}

interface Props {
  title: string
  entries: [string, string][]
  char_id: number
  game_id?: number
  showRollButton?: boolean
}

export const DamageStat: React.FC<Props> = ({
  title,
  entries,
  char_id,
  game_id,
  showRollButton = false,
}) => {
  const { addError } = useGlobalError()
  const { mutate: rollMutation, isLoading } = useMutation(
    () => mutationDmgRoll(char_id, game_id || 0),
    {
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się wykonać rzutu', err?.status)
      },
    }
  )

  const classes = useStyles()
  const filtered = entries.filter(s => s[0] !== 'id').filter(s => s[1] !== '[0, 0]')

  return (
    <Box className={classes.card}>
      {filtered.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant={'button'}>{title}</Typography>
          {showRollButton && <RollButton isDisabled={isLoading} onClick={() => rollMutation()} />}
        </Box>
      )}

      {filtered
        .sort((a, b) => b[1].localeCompare(a[1]))
        .map(d => (
          <Box sx={{ display: 'flex', justifyItems: 'space-between', alignItems: 'center' }}>
            <Box sx={{ flexGrow: '1' }}>
              <StatItem key={d[0]} name={DamageTranslation[d[0]]} value={parseDmg(d[1])} />
            </Box>
          </Box>
        ))}
    </Box>
  )
}

const parseDmg = (dmg: string) => {
  const arr = JSON.parse(dmg)

  if (arr[0] === arr[1]) {
    return arr[0]
  }

  return `${arr[0]}-${arr[1]}`
}
